import { Injectable } from "@angular/core";
import { BaseProvider } from "../../../shared/providers/base-provider";
import { GeoportalLayoutNotifier } from "./geoportal-layout-notifier";
import { GeoportalLayoutState } from "./geoportal-layout-state";

/**
 * GeoportalLayoutProvider — trío provider/notifier/state del layout.
 *
 * @Injectable() SIN providedIn: se lista en GEOPORTAL_PROVIDERS para que
 * Angular lo escopie al inyector de la ruta y llame ngOnDestroy() al
 * desmontar (estado limpio en cada sesión).
 */
@Injectable()
export class GeoportalLayoutProvider extends BaseProvider<
  GeoportalLayoutNotifier,
  GeoportalLayoutState
> {
  constructor() {
    super(GeoportalLayoutNotifier);
  }
}